interface ICandidate {
  candidate: {
    id: string;
    email: string;
    passwordHash: string;
    name: string;
    phoneNumber: string;
  };
  interviewId: string;
  interviewDate: string;
  expirationDate: string;
  jobTitle: string;
  isInvite: boolean;
  interviewStatus: string;
  recommendationStatus?: string;
}

type User = {
  id: number;
  name: string;
  email: string;
  job: string;
  date: string;
  interviewDate?: string;
  status: string;
  actions: any;
};

type CandidateType = {
  id: number;
  candidateId: string;
  interviewId: string;
  name: string;
  email: string;
  job: string;
  date: string;
  interviewDate?: string;
  phoneNumber: string;
  interviewStatus: string;
  invitationStatus: string;
  expirationDate?: string;
  recommendationStatus?: string;
  actions: any;
};

// Converter function
export const convertCandidatesToUsers = (candidates: ICandidate[]): User[] => {
  return candidates?.map((candidateData, index) => ({
    id: index + 1,
    name: candidateData.candidate.name,
    email: candidateData.candidate.email,
    job: candidateData.jobTitle,
    date: new Date(candidateData.interviewDate).toLocaleDateString(),
    interviewDate: new Date(candidateData.interviewDate).toLocaleTimeString(),
    expirationDate: new Date(candidateData.expirationDate).toLocaleDateString(),
    status: candidateData.isInvite ? "Invited" : "Pending",
    recommendationStatus: candidateData.recommendationStatus,
    actions: null,
  }));
};

//Converting to candidate type
export const convertCandidatesToCandidatesType = (
  candidates: ICandidate[]
): CandidateType[] => {
  return candidates?.map((candidateData, index) => ({
    id: index + 1,
    candidateId: candidateData.candidate.id,
    interviewId: candidateData.interviewId,
    name: candidateData.candidate.name,
    email: candidateData.candidate.email,
    job: candidateData.jobTitle,
    phoneNumber: candidateData.candidate.phoneNumber,
    date: new Date(candidateData.interviewDate).toLocaleDateString(),
    interviewDate: new Date(candidateData.interviewDate).toLocaleTimeString(),
    invitationStatus: candidateData.isInvite ? "Invited" : "Pending",
    interviewStatus: candidateData.interviewStatus,
    expirationDate: new Date(candidateData.expirationDate).toLocaleDateString(),
    recommendationStatus: candidateData.recommendationStatus || "N/A",
    actions: null,
  }));
};

export const toLocalDatetimeString = (dateString: string) => {
  if (!dateString) return "";
  // Do not adjust for timezone, just slice the string for input type="datetime-local"
  return dateString.slice(0, 16);
};

/**
 * Converts a Date object to ISO string while preserving local time
 * This prevents timezone conversion issues where the time shifts by timezone offset
 */
export const toLocalISOString = (date: Date): string => {
  if (!date || isNaN(date.getTime())) return "";

  // Get local time components
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  const milliseconds = String(date.getMilliseconds()).padStart(3, "0");

  // Get timezone offset in minutes
  const offsetMinutes = date.getTimezoneOffset();
  const offsetHours = Math.floor(Math.abs(offsetMinutes) / 60);
  const offsetMins = Math.abs(offsetMinutes) % 60;
  const offsetSign = offsetMinutes <= 0 ? "+" : "-";

  // Format as ISO string with timezone offset
  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}${offsetSign}${String(
    offsetHours
  ).padStart(2, "0")}:${String(offsetMins).padStart(2, "0")}`;
};
